import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackTelemetryInPostgres } from "../utils/telemetryApi";

/**
 * Hook to log page views and URL changes to telemetry.
 * Tracks both initial page load and subsequent navigation.
 */
export function useLogPageLoad() {
  const location = useLocation();

  useEffect(() => {
    trackTelemetryInPostgres({
      name: "page_view",
      extra: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
      },
    });
  }, [location.pathname, location.search, location.hash]);
}
